import {
	ArrowForwardIos,
	EditOutlined,
} from "@mui/icons-material";
import {
	Avatar,
	FormControlLabel,
	Grid,
	IconButton,
	Stack,
	Switch,
	Tooltip,
	Typography,
} from "@mui/material";
import { debounce } from "lodash";
import MUIDataTable from "mui-datatables";
import { useEffect, useMemo, useState } from "react";
import { getAllCategory } from "../../apis/ProductCategory";

export default function DataTable({ handleEdit }) {
	const [data, setData] = useState([]);
	const [page, setPage] = useState(0);
	const [filters, setFilters] = useState({ product_only: true });

	const [count, setCount] = useState(0);
	const [rowsCount, setRowsCount] = useState(10);

	const handleSearchChange = useMemo(
		() => debounce((searchText) => {
			setFilters((prev) => ({
				...prev,
				name: searchText,
			}));
		}, 500),
		[],
	);

	useEffect(() => () => handleSearchChange.cancel(), [handleSearchChange]);

	const handleChange = (event) => {
		setFilters((prev) => ({
			...prev,
			product_only: event.target.checked,
		}));
	};

	useEffect(() => {
		getAllCategory(rowsCount, page + 1, filters).then((res) => {
			setData(res.results);
			setCount(res.count);
		});
	}, [page, rowsCount, filters]);

	const columns = [
		{
			name: "id",
			label: "Id",
			options: {
				filter: false,
				sort: true,
				setCellProps: () => ({ sx: { textAlign: "right" } }),
				// customBodyRender: (value, tableMeta, updateValue) => {
				// 	// console.log("yes", tableMeta);
				// 	return tableMeta.rowIndex + 1;
				// },
			},
		},

		{
			name: "name",
			label: "Name",
			options: {
				filter: false,
				sort: false,
				customBodyRender: (value, tableMeta, updateValue) => {
					return <Typography component={"p"}>{value}</Typography>;
				},
			},
		},
		{
			name: "master",
			label: "Parent",
			options: {
				filter: false,
				sort: true,
				customBodyRender: (value, tableMeta, updateValue) => {
					let current = value;
					const names = [];

					while (current) {
						names.push(current);
						current = current.master;
					}

					return (
						<Tooltip
							componentsProps={{
								tooltip: {
									sx: {
										bgcolor: "white",
										color: "black",
										boxShadow: 2,
										fontSize: 14,
										margin: 1,
										maxWidth: "none",
										width: "fit-content",
									},
								},
							}}
							title={
								<Stack
									direction="row"
									spacing={1}
									alignItems="center"
									justifyContent="center"
								>
									{names
										.reverse()
										.map(
											(
												{ name, products_count },
												index,
											) => (
												<Stack
													key={index}
													direction="row"
													alignItems="center"
													spacing={0.5}
												>
													<Typography variant="body2">
														{name}
													</Typography>
													<Typography variant="body2">
														{`(${products_count})`}
													</Typography>

													{index !==
														names.length - 1 && (
															<ArrowForwardIos
																fontSize={"8"}
															/>
														)}
												</Stack>
											),
										)}
								</Stack>
							}

						// arrow
						// placement="top"
						>
							<Typography component="p">
								{value?.name || "-"}
							</Typography>
						</Tooltip>
					);
				},
			},
		},
		{
			name: "products_count",
			label: "Product Count",
			options: {
				filter: false,
				sort: false,
				customBodyRender: (value, tableMeta, updateValue) => {
					return <Typography component={"p"}>{value}</Typography>;
				},
			},
		},

		{
			name: "logo",
			label: "Logo",
			options: {
				filter: true,
				sort: false,
				setCellProps: () => ({ sx: { textAlign: "center" } }),
				customBodyRender: (value, tableMeta, updateValue) => {
					// console.log("yes", value);
					return (
						<Avatar
							alt="Brand Logo"
							src={value?.file}
							sx={{ bgcolor: "primary.main", color: "white" }}
						>
							{data[tableMeta.rowIndex].name.slice(0, 1)}
						</Avatar>
					);
				},
			},
		},

		{
			name: "",
			label: "Action",
			options: {
				filter: false,
				sort: true,
				viewColumns: false,
				customBodyRender: (value, tableMeta, updateValue) => {
					const { rowIndex } = tableMeta;
					const row = data[rowIndex];
					return (
						<Stack direction={"row"}>
							<IconButton
								color="primary"
								onClick={() => handleEdit(row)}
							>
								<EditOutlined />
							</IconButton>
						</Stack>
					);
				},
			},
		},
	];

	const options = {
		jumpToPage: true,
		selectableRows: "none",
		download: false,
		filter: false,
		// filterType: "multiselect",
		serverSide: true,
		print: false,
		count: count,
		page: page,
		rowsPerPage: rowsCount,
		rowsPerPageOptions: [10, 25, 100],
		onChangePage(currentPage) {
			setPage(currentPage);
		},
		onChangeRowsPerPage(numberOfRows) {
			setRowsCount(numberOfRows);
		},
		onSearchChange: handleSearchChange,
		onColumnSortChange: (changedColumn, direction) => {
			// setSortingValues(
			// 	direction === "desc" ? `-${changedColumn}` : `${changedColumn}`
			// );
			// setPage(0)
			// setSortFields(temp);
		},

		// onTableChange: (action, tableState) => {
		// 	switch (action) {
		// 		case "sort":
		// 			sortTable(tableState.page, tableState.sortOrder);
		// 			break;
		// 		default:
		// 			console.log("action not handled.");
		// 	}
		// },
	};

	return (
		<Grid container justifyContent="center">
			<Grid
				item
				md={8}
				sx={{ display: "flex", justifyContent: "flex-end" }}
			>
				<FormControlLabel
					value="bottom"
					control={
						<Switch
							color="primary"
							checked={filters.product_only}
							onChange={handleChange}
						/>
					}
					label="With Product Only"
					labelPlacement="start"
				/>
			</Grid>
			<Grid item md={8}>
				<MUIDataTable
					title={"Product Categories"}
					data={data}
					columns={columns}
					options={options}
				/>
			</Grid>
		</Grid>
	);
}
